import * as log from 'loglevel'

export const Logger = log

const methodFactory = Logger.methodFactory

Logger.methodFactory = (methodName, level, loggerName) => {
  if (loggerName !== undefined && loggerName !== 'String') {
    const prefix = `%c[ ${String(loggerName)} ]`

    return methodFactory(methodName, level, loggerName).bind(
      logToConsole,
      prefix,
      'font-size: 10px; font-weight: bold'
    )
  } else {
    return methodFactory(methodName, level, loggerName)
  }
}

function logToConsole(...args: any[]): void {
  // tslint:disable-next-line:no-console - This is the only place where the console.log can be used
  console.log(...args)
}

export function loggerFor(name: string): log.Logger {
  return Logger.getLogger(name)
}
